import { render, staticRenderFns } from "./TasksUsuarioMesAtualStats.vue?vue&type=template&id=5c396f44"
import script from "./TasksUsuarioMesAtualStats.vue?vue&type=script&lang=js"
export * from "./TasksUsuarioMesAtualStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports